<style lang="scss">
  @import './base.scss';
  @import './user-attribute.scss';
</style>
<template>
  <div class="user-attribute module-wrap clearfix" :class="[showAttribute.length === 0 ? 'position-reduce' : '']">
    <!-- 模块名称 -->
    <h3 class="module-label">{{$t('addUserGroup.userAttribute.title')}}</h3>
    <!-- 模块关系 -->
    <expr-relation
      v-if="showAttribute.length > 0"
      :relation="returnData.relation || '$and'"
      @on-choice-relation="choiceRelation"
    >
    </expr-relation>
    <!-- 模块内容 -->
    <div class="module-content">
      <div v-for="(item, index) in showAttribute" :key="item.value" style="position: relative;" :class="[item.value]">
      <connecting-line
          v-if="index === 0 || index === attributeList.length - 1"
          :end-line="index === attributeList.length - 1"
          ></connecting-line>
      <!-- 用户属性item -->
        <attribute-item
          :dataType="item"
          :index="index"
          :content-data="item.value === 'region' ? returnData['user_region'] : returnData[item.value]"
          @change-item-data="changedata"
          @delete-attr-item="deleteItem"
        >
        </attribute-item>
      </div>
      <!-- 添加用户属性下拉表 -->
      <div v-if="showAttribute.length < 5" class="user-attribute-selected">
        <connecting-line
          v-if="showAttribute.length > 0"
          btn-line></connecting-line>
        <Select :class="[showAttribute.length === 0 ? 'select-center' : '']" v-model="model" @on-change="selectAttribute" :placeholder="$t('addUserGroup.userAttrSel.placeholder')" style="width:200px">
          <Option-group :label="$t('addUserGroup.userAttrSel.origin')">
              <Option v-for="item in originList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Option-group>
          <Option-group :label="$t('addUserGroup.userAttrSel.mobile')">
              <Option v-for="item in mobileList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Option-group>
        </Select>
      </div>
    </div>
  </div>
</template>
<script>
  import bus from '../../libs/bus';
  import busModual from '../../libs/busModual';
  import connectingLine from './connecting-line';
  import exprRelation from './expr-relation';
  import attributeItem from './user-attribute-item';

  export default {
    name: 'userAttribute',
    props: {
      returnData: Object,
      attributeExp: Object,
    },
    data() {
      return {
        // 用户属性配置列表
        configList: this.configdata(),
        // 下拉列表来源和属性
        originList: this.configdata().originList,
        // 下拉列表设备属性
        mobileList: this.configdata().mobileList,
        attributeList: this.configdata().attributeList,
        showAttribute: [],
        keys: [],
        model: '',
        // 用户分群list页展示相关文案
        attributeDetail: {},
        // 初始用户类型
        initialType: busModual.userRangeType,
        // 存储用户属性表达式
        mapRetrunData: {},
      };
    },
    components: {
      attributeItem,
      connectingLine,
      exprRelation,
    },
    filters: {

    },
    computed: {
      usertype() {
        return busModual.userRangeType;
      },
    },
    mounted() {
      // 监听用户类型变化，生成表达式key值对应修改 如：newuser_mobile_info
      bus.$on('on-usergroup-type-change', () => {
        this.getAttributeExp();
      });
      // 置空操作
      bus.$on('on-usergroup-reset', () => {
        this.model = '';
        this.showAttribute = [];
        this.originList = this.configdata().originList;
        this.mobileList = this.configdata().mobileList;
      });
      // 恢复操作
      bus.$on('on-usergroup-recover', () => {
        this.model = '';
        this.getShowAttrList();
      });
      bus.$on('on-change-lang', this.getShowAttrList);
      // 返回数据里与用户属性列表做对比，有的则展示
      if (!Object.keys(this.returnData).length) return;
      this.mapRetrunData = JSON.parse(JSON.stringify(this.returnData));
      this.getShowAttrList();
    },
    beforeDestroy() {
      bus.$off('on-change-lang', this.getShowAttrList);
    },
    methods: {
      getShowAttrList() {
        this.mobileList = this.configdata().mobileList;
        this.originList = this.configdata().originList;
        this.attributeList = this.configdata().attributeList;
        const array = Object.keys(this.returnData);
        const result = [];
        this.attributeList.forEach((item) => {
          array.forEach((val) => {
            if (val.indexOf(item.value) > -1) {
              result.push(item);
              this.getList(item.value, true);
            }
          });
        });
        this.showAttribute = result;
      },
      // 属性 -> item配置列表
      configdata() {
        const obj = {};
        const originList = [{
          value: 'partner_info',
          idname: 'partnerId',
          label: this.$t('addUserGroup.userAttrSel.originItem[0].label'),
          placeholder: this.$t('addUserGroup.userAttrSel.originItem[0].placeholder'),
        }, {
          value: 'region',
          idname: 'countryId',
          label: this.$t('addUserGroup.userAttrSel.originItem[1].label'),
          placeholder: this.$t('addUserGroup.userAttrSel.originItem[1].placeholder'),
        }, {
          value: 'isp_info',
          idname: 'ispId',
          label: this.$t('addUserGroup.userAttrSel.originItem[2].label'),
          placeholder: this.$t('addUserGroup.userAttrSel.originItem[2].placeholder'),
        }];
        const mobileList = [{
          value: 'mobile_info',
          idname: 'mobileId',
          label: this.$t('addUserGroup.userAttrSel.mobileItem[0].label'),
          placeholder: this.$t('addUserGroup.userAttrSel.mobileItem[0].placeholder'),
        }, {
          value: 'os_info',
          idname: 'osId',
          label: this.$t('addUserGroup.userAttrSel.mobileItem[1].label'),
          placeholder: this.$t('addUserGroup.userAttrSel.mobileItem[1].placeholder'),
        }];
        obj.originList = originList;
        obj.mobileList = mobileList;
        obj.attributeList = originList.concat(mobileList);
        return obj;
      },
      // and or点击事件
      choiceRelation(str) {
        this.returnData.relation = str;
        this.getAttributeExp();
      },
      // 添加用户属性
      selectAttribute(value) {
        this.getList(value, true);
        // 派发选择属性的事件
        setTimeout(() => {
          this.model = '';
          bus.$emit('selected-attr-item', value);
        }, 0);
      },
      // 删除某个用户属性
      deleteItem(value) {
        this.model = '';
        this.getList(value, false);
        const key = value === 'region' ? 'user_region' : value;
        delete this.mapRetrunData[key];
        delete this.returnData[key];

        delete this.attributeDetail[key];

        this.getAttributeExp();
      },
      /**
       * 获取展示列表、下拉列表
       * @param value {String} 每种用户属性对应的标识
       * @param flag  {Boolean} true为展示列表增加item、下拉列表减少item，false相反
       **/
      getList(value, flag) {
        if (flag) {
          this.configList.attributeList.forEach((v) => {
            if (v.value === value) {
              this.showAttribute.push(v);
            }
          });
          this.originList = this.originList.filter(x => x.value !== value);
          this.mobileList = this.mobileList.filter(x => x.value !== value);
        } else {
          this.showAttribute = this.showAttribute.filter(x => x.value !== value);
          const originList = this.configList.originList;
          const mobileList = this.configList.mobileList;
          originList.forEach((v) => {
            if (v.value === value) {
              this.originList.push(v);
            }
          });
          mobileList.forEach((v) => {
            if (v.value === value) {
              this.mobileList.push(v);
            }
          });
        }
      },
      /**
       * 获取展示列表、下拉列表、表达式
       * @param key {String} 每种用户属性对应的标识 （用于用户属性的key）
       * @param obj  {Object} 存储的用户属性对应的id
       * @param name  {Array} 存储的用户属性id对应的value，如地区：89对应"拉脱维亚"
       **/
      changedata(key, obj, name) {
        this.mapRetrunData[key] = obj[key];
        if (name.length > 0) {
          this.attributeDetail[key] = name;
        } else {
          // name为空时删除对应文案
          delete this.attributeDetail[key];
        }
        this.getAttributeExp();
      },
      // 获取表达式
      getAttributeExp() {
        const list = this.mapRetrunData;
        const relation = this.returnData.relation || '$and';
        const result = [];
        Object.keys(list).forEach((v) => {
          if (v !== 'relation') {
            const tmp = {};
            // flag为是否整合的判断，当目标全选时$in为空数组，处理为不传递此数据
            let flag = false;
            const item = list[v];
            Object.keys(item).forEach((idname) => {
              if (item[idname].$in.length > 0) flag = true;
            });
            // 排除“国家及地区”
            if (flag && v !== 'user_region') {
              tmp[v] = list[v];
              result.push(tmp);
            // 国家及地区，只选国家、省份或都选传不同key
            } else if (flag && v === 'user_region') {
              if (!item.countryId || !item.provinceId) return;
              if (item.countryId.$in.length > 0 && item.provinceId.$in.length > 0) {
                tmp[v] = list[v];
              } else if (item.countryId.$in.length > 0 && item.provinceId.$in.length <= 0) {
                tmp.user_country = {
                  countryId: item.countryId,
                };
              } else if (item.countryId.$in.length <= 0 && item.provinceId.$in.length > 0) {
                tmp.user_province = {
                  provinceId: item.provinceId,
                };
              }
              result.push(tmp);
            }
          }
        });
        this.attributeExp.relation = relation;
        this.attributeExp.expr = result;
        this.attributeExp.detail = this.attributeDetail;
        return {
          relation,
          expr: result,
          detail: this.attributeDetail,
        };
      },
    },
    watch: {
      returnData() {
        this.getShowAttrList();
        // this.getAttributeExp();
      },
    },
  };
</script>
